import { Injectable } from '@angular/core';

import { Addressee } from '../shared/message/Addressee';

@Injectable({
  providedIn: 'root',
})
export class AddresseeServiceService {
  addressees: Addressee[] = [];

  constructor() {
    this.addressees = [];
  }

  /**
   * 添加选择的收信人
   */
  addAddressee(addres: Addressee): void {
    this.addressees.push(addres);
  }

  addAddressees(ads: Addressee[]): void {
    this.addressees = ads;
  }

  getAddressees(): Addressee[] {
    return this.addressees;
  }
}
